import { getProfileDataThunk, leaveOrganizationThunk } from '../../../../../store/workspace/thunks';
import { RemoveMemberIcon, RemoveMemberSquareIcon } from '../../../../../assets/icons';
import { selectSelectedMemberDetail } from '../../../../../store/workspace/selectors';
import { setConfirmRemoveMemberModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import { selectUserId } from '../../../../../store/auth/selectors';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import { useState } from 'react';

export default function ConfirmRemoveMember() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const member = useSelector(selectSelectedMemberDetail);
    const [isLoading, setIsLoading] = useState(false);

    const closeModal = () => dispatch(setConfirmRemoveMemberModal(false));

    const removeMember = () => {
        if (!userId || !member) return;

        setIsLoading(true);
        dispatch(leaveOrganizationThunk({
            action: 'remove',
            email: member.email,
        }))
            .unwrap()
            .then(() => {
                closeModal();
                dispatch(getProfileDataThunk());
            })
            .catch(() => {
                setIsLoading(false);
            });
    };

    return (
        <Modal
            size='sm'
            actions='both'
            title='Remove member'
            closeFunc={closeModal}
            icon={<RemoveMemberSquareIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                disabled: isLoading,
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Remove',
                type: 'Error',
                loading: isLoading,
                onClick: removeMember,
            }}
        >
            <RemoveMemberIcon />
            <span className={styles.text}>
                Are you sure you want to remove as member?
            </span>
        </Modal>
    );
};
